import { apiGet, apiPost, apiDelete } from '../../api/index';
import { urlMallas } from '../../api/urls';

export function filter(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlMallas}/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function get(id, callback) {
  return apiGet(`${urlMallas}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function save(obj, callback) {
  return apiPost(`${urlMallas}`, obj)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function remove(id, callback) {
  return apiDelete(`${urlMallas}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchFormDatas({ onSuccess, onError }) {
  return apiGet(`${urlMallas}/form_data`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchEditSubjectsFormData(periodoId, { onSuccess, onError }) {
  return apiGet(`${urlMallas}/form_data_edit_subjects/${periodoId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchAllSubjectsBySemesters({
  periodoId, carreraId, onSuccess, onError,
}) {
  return apiGet(`${urlMallas}/subjects_by_semesters/${periodoId}/${carreraId}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function saveSubjects(data, { onSuccess, onError }) {
  return apiPost(`${urlMallas}/save_subjects`, data)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}
